var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      attrs: {
        height: 900,
        width: 900,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("rect", {
        attrs: {
          x: "22.33",
          y: "37.07",
          rx: "0",
          ry: "0",
          width: "276.55",
          height: "8",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "18.74",
          y: "59.07",
          rx: "0",
          ry: "0",
          width: "809.85",
          height: "123.95",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "23.85",
          y: "198.07",
          rx: "0",
          ry: "0",
          width: "809.86",
          height: "39",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "22.44",
          y: "247.07",
          rx: "0",
          ry: "0",
          width: "404.47",
          height: "149",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "427",
          y: "247.07",
          rx: "0",
          ry: "0",
          width: "404.77",
          height: "148.94",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "22.7",
          y: "17.07",
          rx: "0",
          ry: "0",
          width: "206.86",
          height: "12",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }